import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingSkyscraper } from "@tabler/icons-react";
import { GruposEmpresasDef } from "./GruposEmpresasDef";

export const GruposEmpresasHelpText = "* Aquí podra ver todos los grupos de empresas.";
export const GruposEmpresasIcon = IconBuildingSkyscraper;

export class GruposEmpresas extends Entity<GruposEmpresasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new GruposEmpresasDef(), parentKeys);
        this.Form = import('./GruposEmpresasForm').then((module) => module.GruposEmpresasForm);
        this.Title = "Grupos de Empresas";
        this.Icon = GruposEmpresasIcon;
        this.HelpText = GruposEmpresasHelpText;     
    }
}